import React from "react"
import Icon from "./Icon"
import neonPrairieNights from "../../../../../assets/images/channel_pages/neon-prairie-nights.png"

// Instagram-style sponsored post for "Neon Prairie Nights" — Meta channel hero.
// Uses CSS custom properties (set on the parent .mpp) for accent theming via
// the channel's gradient + accent color. Float chips animate via @keyframes vsFloat.

const MetaAdPreview = () => (
  <div style={{ position: "relative", width: "100%", maxWidth: 460, margin: "0 auto" }}>
    {/* AI insight chip (top-left) */}
    <div style={{
      position: "absolute", top: -16, left: -28, zIndex: 4,
      padding: "8px 12px 8px 10px",
      background: "rgba(15,12,42,.72)",
      backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 10, color: "#fff",
      display: "flex", alignItems: "center", gap: 8,
      fontSize: 12, fontWeight: 600, whiteSpace: "nowrap",
      boxShadow: "0 10px 28px rgba(0,0,0,.28)",
      animation: "vsFloat 6s ease-in-out infinite",
    }}>
      <span style={{
        width: 18, height: 18, borderRadius: 5,
        background: "linear-gradient(135deg,#B794FF,#FF6CD9)",
        display: "flex", alignItems: "center", justifyContent: "center", color: "#fff",
      }}>
        <Icon name="sparkles" size={11} stroke={2.4}/>
      </span>
      <span>Creative v3 · +41% CTR</span>
    </div>

    {/* IG ad card */}
    <div style={{
      position: "relative", zIndex: 2,
      background: "#fff", borderRadius: 16,
      boxShadow: "0 30px 80px rgba(10,0,40,.45), 0 10px 24px rgba(10,0,40,.25)",
      overflow: "hidden",
      transform: "perspective(1400px) rotateY(-6deg) rotateX(2deg)",
      transformOrigin: "center",
    }}>
      <div style={{ padding: "12px 14px", display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{
          width: 34, height: 34, borderRadius: "50%",
          background: "conic-gradient(from 210deg, #FFD166, #EF476F, #6A3AFB, #FFD166)",
          padding: 2,
        }}>
          <div style={{
            width: "100%", height: "100%", borderRadius: "50%",
            background: "#fff",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 12, fontWeight: 800, color: "#0F172A", letterSpacing: "-.02em",
          }}>RH</div>
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 13.5, fontWeight: 700, color: "#0F172A", lineHeight: 1.2 }}>
            revivalhall.room
            <span style={{ marginLeft: 6, fontSize: 11, fontWeight: 600, color: "var(--mpp-accent)" }}>· Sponsored</span>
          </div>
          <div style={{ fontSize: 11.5, color: "#64748B", marginTop: 1 }}>Dallas, TX</div>
        </div>
        <span style={{ color: "#0F172A" }}><Icon name="more" size={16}/></span>
      </div>

      <div style={{
        position: "relative", aspectRatio: "1 / 1",
        overflow: "hidden",
        display: "flex", flexDirection: "column", justifyContent: "space-between",
        padding: 18,
      }}>
        <img src={neonPrairieNights} alt="Neon Prairie Nights" style={{
          position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0,
        }}/>
        <div style={{
          position: "absolute", inset: 0, zIndex: 1,
          background: "linear-gradient(180deg, rgba(10,0,30,.25) 0%, rgba(10,0,30,0) 35%, rgba(10,0,30,.55) 100%)",
        }}/>
        <div style={{
          position: "relative", zIndex: 2,
          display: "flex", justifyContent: "space-between", alignItems: "flex-start",
          color: "#fff", gap: 8,
        }}>
          <div style={{
            fontSize: 10, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase",
            padding: "4px 9px", borderRadius: 999,
            background: "rgba(10,0,30,.4)", backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)",
            border: "1px solid rgba(255,255,255,.28)",
            whiteSpace: "nowrap",
          }}>LIVE · SAT APR 26</div>
          <div style={{ fontSize: 11, fontWeight: 600, opacity: .9, whiteSpace: "nowrap", textShadow: "0 1px 6px rgba(0,0,0,.6)" }}>9PM · 21+</div>
        </div>
        <div style={{ position: "relative", zIndex: 2, color: "#fff" }}>
          <div style={{ fontSize: 10.5, fontWeight: 600, letterSpacing: ".12em", textTransform: "uppercase", opacity: .9, marginBottom: 6, textShadow: "0 1px 8px rgba(0,0,0,.6)" }}>
            Revival Hall presents
          </div>
          <div style={{
            fontFamily: "Manrope, system-ui, sans-serif",
            fontSize: 26, lineHeight: 1.02, fontWeight: 800, letterSpacing: "-.03em",
            textShadow: "0 2px 18px rgba(0,0,0,.55)",
          }}>
            Neon Prairie Nights
          </div>
          <div style={{ fontSize: 12, fontWeight: 600, opacity: .92, marginTop: 6, textShadow: "0 1px 6px rgba(0,0,0,.6)" }}>
            An Indie Pop Showcase
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 7, marginTop: 10, fontSize: 11, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", textShadow: "0 1px 6px rgba(0,0,0,.6)" }}>
            <span style={{ width: 7, height: 7, borderRadius: "50%", background: "#FF6CD9", boxShadow: "0 0 10px #FF6CD9" }}/>
            Revival Hall · Dallas
          </div>
        </div>
      </div>

      <div style={{
        display: "flex", alignItems: "center",
        background: "#F8FAFC", padding: "12px 14px", gap: 12,
        borderTop: "1px solid rgba(15,23,42,.05)",
      }}>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: "#0F172A" }}>Get Tickets</div>
          <div style={{ fontSize: 11, color: "#64748B", marginTop: 1 }}>revivalhall.room</div>
        </div>
        <div style={{
          padding: "7px 14px", borderRadius: 8,
          background: "var(--mpp-gradient)", color: "#fff",
          fontSize: 12, fontWeight: 700,
          boxShadow: "var(--mpp-cta-shadow)",
          display: "inline-flex", alignItems: "center", gap: 5,
        }}>
          <Icon name="ticket" size={12} stroke={2.4}/> Buy
        </div>
      </div>

      <div style={{ padding: "10px 14px 12px", display: "flex", alignItems: "center", gap: 14, color: "#0F172A" }}>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
          <Icon name="heart" size={16}/>
          <span style={{ fontSize: 11.5, fontWeight: 600 }}>4.2k</span>
        </div>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
          <Icon name="message" size={16}/>
          <span style={{ fontSize: 11.5, fontWeight: 600 }}>312</span>
        </div>
        <div style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
          <Icon name="share" size={16}/>
          <span style={{ fontSize: 11.5, fontWeight: 600 }}>89</span>
        </div>
        <div style={{ marginLeft: "auto" }}><Icon name="bookmark" size={16}/></div>
      </div>
    </div>

    {/* Audience chip (bottom-right) */}
    <div style={{
      position: "absolute", bottom: 26, right: -42, zIndex: 4,
      padding: "10px 12px",
      background: "rgba(255,255,255,.94)",
      borderRadius: 10,
      boxShadow: "0 14px 32px rgba(10,0,40,.28)",
      display: "flex", alignItems: "center", gap: 10,
      animation: "vsFloat 7s ease-in-out -2s infinite",
    }}>
      <div style={{ display: "flex" }}>
        {["#FFB86B", "#6A3AFB", "#34C759", "#FF6CD9"].map((c, i) => (
          <div key={i} style={{
            width: 22, height: 22, borderRadius: "50%",
            background: c, border: "2px solid #fff",
            marginLeft: i === 0 ? 0 : -7,
          }}/>
        ))}
      </div>
      <div style={{ lineHeight: 1.15 }}>
        <div style={{ fontSize: 10.5, fontWeight: 600, color: "#64748B", letterSpacing: ".06em", textTransform: "uppercase" }}>Audience</div>
        <div style={{ fontSize: 12.5, fontWeight: 700, color: "#0F172A" }}>124k music fans · 25–34</div>
      </div>
    </div>

    {/* Cost chip (top-right) */}
    <div style={{
      position: "absolute", top: 96, right: -20, zIndex: 4,
      padding: "10px 12px",
      background: "rgba(15,12,42,.78)",
      backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)",
      border: "1px solid rgba(255,255,255,.14)",
      borderRadius: 10, color: "#fff",
      whiteSpace: "nowrap",
      boxShadow: "0 10px 28px rgba(0,0,0,.28)",
      animation: "vsFloat 8s ease-in-out -1s infinite",
    }}>
      <div style={{ fontSize: 10, fontWeight: 600, opacity: .7, letterSpacing: ".08em", textTransform: "uppercase" }}>Cost / ticket</div>
      <div style={{ fontSize: 17, fontWeight: 800, letterSpacing: "-.02em", marginTop: 2 }}>
        $2.14 <span style={{ fontSize: 11, fontWeight: 700, color: "#6AFF9B" }}>▼ 38%</span>
      </div>
    </div>
  </div>
)

export default MetaAdPreview
